import { createSelector } from 'reselect';
import { uninitState, statusSuccess, successState } from '@grandvisionhq/state';
import { getPrescriptionGlasses, frameSkuProp, lensTypeSkuProp, packageSkuProp } from '../selectors.internal.js';

const getBundles = createSelector(getPrescriptionGlasses, (pg)=>pg.bundles
);
/**
 * Frames
 */ const getBundleFrames = createSelector(getBundles, (b)=>b.frames
);
const getBundleFrame = createSelector(getBundleFrames, frameSkuProp, (frames, frameSku)=>frames[frameSku]
);
/**
 * Lens Types
 */ const getBundleLensTypes = createSelector(getBundles, (b)=>b.lensTypes
);
const getBundleLensType = createSelector(getBundleLensTypes, lensTypeSkuProp, (lensTypes, lensTypeSku)=>lensTypes[lensTypeSku]
);
/**
 * Packages
 */ const getBundlePackages = createSelector(getBundles, (b)=>b.packages
);
const getBundlePackage = createSelector(getBundlePackages, packageSkuProp, (packages, packageSku)=>packages[packageSku]
);
/**
 * Add-ons
 */ const getBundleAddOns = createSelector(getBundles, (b)=>b.addOns
);
const convertToParamArray = (o)=>Object.entries(o).map(([name, param])=>({
            name,
            values: param ? param.values : new Set()
        })
    )
;
const getOpticalParameters = createSelector(getBundleFrame, getBundleLensType, (bundle, lensType)=>{
    if (!bundle) {
        return uninitState();
    }
    if (!statusSuccess(lensType)) {
        return lensType;
    }
    return successState([
        ...convertToParamArray(lensType.result.opticalParameters),
        ...convertToParamArray(bundle.opticalParameters), 
    ]);
});

export { getBundleAddOns, getBundleFrame, getBundleFrames, getBundleLensType, getBundleLensTypes, getBundlePackage, getBundlePackages, getOpticalParameters };
//# sourceMappingURL=selectors.internal.js.map
